export class User {
    Id: string;
    GivenName: string;
    Surname: string;
    Email: string;
    RegisteredOn: Date;
    Role: string;
    OfficeIds: any;

    constructor(data?: any) {
        if (data) {
            this.Id = data.Id;
            this.GivenName = data.GivenName;
            this.Surname = data.Surname;
            this.Email = data.Email;
            this.Role = data.Role;
            this.OfficeIds = [];
        }
    }
}



// WEBPACK FOOTER //
// ./Angular/app/_models/user.model.ts